const DAY = 24 * 3600 * 1000;

export const RELATED_TASKS_MAX_CLOSED = 7 * DAY;

// This is a date also set in the Tasks Service
export const AVeryLargeDate = "3000-01-01T00:00:00.000Z";
